import LayoutConfigTypes from "@/core/config/LayoutConfigTypes";

const config: LayoutConfigTypes = {
    themeName: "Metronic",
    themeVersion: "8.0.37",
    demo: "demo1",
    main: {
        type: "default",
        primaryColor: "#0066CC",
        logo: {
            dark: "/media/logos/Logo-Storms-Software.png",
            light: "/media/logos/Logo-Storms-Software.png",
        },
    },
    illustrations: {
        set: "sketchy-1",
    },
    loader: {
        logo: "/media/logos/logo-1-dark.svg",
        display: true,
        type: "default",
    },
    scrollTop: {
        display: true,
    },
    header: {
        display: true,
        menuIcon: "font",
        width: "fluid",
        fixed: {
            desktop: true,
            tabletAndMobile: true,
        },
    },
    toolbar: {
        display: true,
        width: "fluid",
        fixed: {
            desktop: true,
            tabletAndMobile: true,
        },
    },
    aside: {
        display: false,
        theme: "light",
        fixed: true,
        menuIcon: "font",
        minimized: false,
        minimize: true,
        hoverable: true,
    },
    content: {
        width: "fixed",
    },
    footer: {
        width: "fluid",
    },
};

export default config;
